import { useState } from 'react';
import { InvoicesContent } from '../../../billing/invoices/InvoicesContent';

// Own sessionStorage keys so this embedded instance never fights the
// standalone billing section's saved filters (billing's PracticeInvoicesTab
// hardcodes its own pair of keys - this is the Accounts-owned equivalent,
// since InvoicesContent itself is used directly rather than through that
// wrapper).
const STATUS_FILTER_STORAGE_KEY = 'fv_accounts_practiceInvoiceStatusFilter';
const PRACTICE_FILTER_STORAGE_KEY = 'fv_accounts_practiceInvoicePracticeFilter';

interface PracticeInvoicesTabAccountsProps {
    practiceId: string;
}

// The exact billing Invoices tab experience (status cards, search/filters/
// sort, table, pagination, invoice <-> charge drawer swap), scoped to this
// practice and fit to the detail pane's height - identical to Practice
// insights' Invoices tab, just mounted inside the Accounts practice detail
// page instead.
export function PracticeInvoicesTabAccounts({ practiceId }: PracticeInvoicesTabAccountsProps) {
    const [openInvoiceId, setOpenInvoiceId] = useState<string | null>(null);

    return (
        <InvoicesContent
            practiceId={practiceId}
            openInvoiceId={openInvoiceId}
            onOpenInvoice={setOpenInvoiceId}
            onCloseInvoice={() => setOpenInvoiceId(null)}
            statusFilterStorageKey={STATUS_FILTER_STORAGE_KEY}
            practiceFilterStorageKey={PRACTICE_FILTER_STORAGE_KEY}
            fillHeight
        />
    );
}
